import {
    TRANSLATION_RECEIVE_TRANSLATIONS,
    TRANSLATION_FILTER_BY_SEARCH_STRING,
    TRANSLATION_DIALOG_ADD_TRANSLATION,
    TRANSLATION_DIALOG_EDIT_TRANSLATION,
    TRANSLATION_CANCEL_ADD_EDIT_TRANSLATION,
    TRANSLATION_RECEIVE_ADD_EDIT_TRANSLATION,
    TRANSLATION_RECEIVE_ADD_EDIT_TRANSLATION_ERROR,
    TRANSLATION_SEND_ADD_EDIT_TRANSLATION
} from '../config/actions';
import TranslationsHelper from '../helpers/translationsHelper';

let defaultState = {
    translations: [],
    searchString: '',
    addEditDialog: {
        open: false,
        translationId: false,
        key: '',
        strings: {
            de: '',
            en: ''
        },
        errors: false,
        loading: false,
        translationType: 'SHORT'
    }
};

const translationReducer = (state = defaultState, action) => {
    switch (action.type) {
        case(TRANSLATION_RECEIVE_TRANSLATIONS):
            if (action.setAllVisible) {
                if (state.searchString.length === 0) {
                    TranslationsHelper.setAllTranslationsVisible(true, action.data);
                } else {
                    TranslationsHelper.setAllTranslationsVisible(false, action.data);
                    TranslationsHelper.setTranslationsVisibleBySearchString(state.searchString, action.data, action.data);
                }
            }
            return Object.assign({}, state, {
                translations: action.data
            });
        case(TRANSLATION_FILTER_BY_SEARCH_STRING):
            let translations = JSON.parse(JSON.stringify(state.translations));
            if (action.searchString.length === 0) {
                translations = TranslationsHelper.setAllTranslationsVisible(true, translations);
            } else {
                translations = TranslationsHelper.setAllTranslationsVisible(false, translations);
                translations = TranslationsHelper.setTranslationsVisibleBySearchString(action.searchString, translations, translations);
            }
            return Object.assign({}, state, {
                translations: translations,
                searchString: action.searchString
            });
        case(TRANSLATION_DIALOG_ADD_TRANSLATION):
            return Object.assign({}, state, {
                addEditDialog: {
                    open: true,
                    translationId: false,
                    key: '',
                    strings: {
                        de: '',
                        en: ''
                    },
                    translationType: 'SHORT',
                    errors: false,
                    loading: false
                }
            });
        case(TRANSLATION_DIALOG_EDIT_TRANSLATION):
            let strings = Object.assign({}, state.addEditDialog.strings, {
                de: action.de,
                en: action.en
            });
            return Object.assign({}, state, {
                addEditDialog: {
                    open: true,
                    translationId: action.id,
                    key: action.key,
                    strings: strings,
                    translationType: action.translationType,
                    errors: false,
                    loading: false
                }
            });
        case(TRANSLATION_CANCEL_ADD_EDIT_TRANSLATION):
            return Object.assign({}, state, {
                addEditDialog: {
                    open: false,
                    translationId: false,
                    key: '',
                    strings: {
                        de: '',
                        en: ''
                    },
                    translationType: 'SHORT',
                    errors: false,
                    loading: false
                }
            });
        case(TRANSLATION_SEND_ADD_EDIT_TRANSLATION):
            return Object.assign({}, state, {
                addEditDialog: Object.assign({}, state.addEditDialog, {
                    loading: true
                })
            });
        case(TRANSLATION_RECEIVE_ADD_EDIT_TRANSLATION):
            return Object.assign({}, state, {
                addEditDialog: {
                    open: false,
                    translationId: false,
                    key: '',
                    strings: {
                        de: '',
                        en: ''
                    },
                    translationType: 'SHORT',
                    errors: false,
                    loading: false
                }
            });
        case(TRANSLATION_RECEIVE_ADD_EDIT_TRANSLATION_ERROR):
            return Object.assign({}, state, {
                addEditDialog: {
                    open: true,
                    errors: action.data.errors,
                    loading: false
                }
            });
        default:
            return state;
    }
};

export default translationReducer;